import { Box } from "@chakra-ui/react";

export const Footer = () => {
  return (
    <Box
      w="100vw"
      h="1rem"
      backgroundColor="brand.darkblue"
      zIndex={10}
      marginTop={4}
    />
  );
};
